/* eslint-disable class-methods-use-this */

import Country from '../models/Country';
import Data from './Data';

class Countries extends Data {
    constructor() {
        super(Country);
    }

    async reload() {
        const countries = [
            { value: 'CH', label: 'Schweiz' },
            { value: 'LI', label: 'Liechtenstein' },
            { value: 'DE', label: 'Deutschland' },
            { value: 'AT', label: 'Österreich' },
        ];

        this.data = countries.map(data => new Country(data));

        return this.data;
    }
}

export default new Countries();
